<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Bank Transaction Code</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.prefix"
              readonly
              label="Prefix"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.month"
              readonly
              label="Month"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model="item.year"
              readonly
              label="Year"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              flat
              dense
              background-color="white"
              v-model.number="item.sequence"
              label="Sequence"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" @click="close">
          close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save" v-if="$rbac.can('bank-statement.update')">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-upload",
  props: {
    dialog: Boolean,
    item: Object,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.item);
      this.$emit("close");
    },
  },
};
</script>

<style></style>
